const getIconName = (type) => {
  if (type === 'Kickoff') {
    return 'icon-announcement';
  }
  if (type === 'Pass_success') {
    return 'icon-info';
  }
  if (['Goal', 'Free_kick_hit', 'Goal_with_assist', 'Penalty_successful'].includes(type)) {
    return 'icon-ball-green';
  } else if(['Penalty_missed'].includes(type)){
    return 'icon-ball-red';
  }
  return 'icon-announcement';
}

const getHighlightsIcon = (type, goals) => {
  if (type === 'Card_yellow') {
    return '<i class="icon-yellow-card"></i>';
  }
  if (type === 'Card_red') {
    return '<i class="icon-red-card"></i>';
  }
  if (['Goal', 'Goal_with_assist', 'Free_kick_hit', 'Penalty_successful', 'Penalty_missed'].includes(type)) {
    return goals;
  }
  return type;
}

const getHighlightsOnlyIcon = (type, goals) => {
  if (type === 'Card_yellow') {
    return '<span class="pointer"></span><i class="icon-yellow-card"></i>';
  }
  if (type === 'Card_red' || type === 'Card_yellow_red') {
      return '<span class="pointer"></span><i class="icon-red-card"></i>';
  }
  if (['Goal', 'Penalty_successful', 'Goal_with_assist', 'Free_kick_hit'].includes(type)) {
      return '<span class="pointer"></span><i class="icon-ball-green"></i>';
  }
  return type;
}

function camelize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
}

export default ({ report, stats, highlights, data }) => (`
${highlights?.map((item) => `
<div class="highlight d-flex align-items-center">
  <div class="highlight__type">
    <div class="highlight__content">
      ${getHighlightsIcon(item.actiontype, item.goals)}
    </div>
  </div>
  <div class="highlight__title">${item.action_name}</div>
  <div class="highlight__date ml-auto">${item.minute}’</div>
</div>
`).join('')}
`);
